import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { DadoPessoalModel } from './dados-pessoais.model';

@Injectable()
export class DadosPessoaisService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  saveDadoPessoal(dado: FormData): Observable<DadoPessoalModel> {
    return this.httpClient.post<DadoPessoalModel>(this.apiURL + '/dado-pessoal/adicionar', dado, this.httpOptions);
  }

  getTiposDados(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + '/dado-pessoal/view/tipos-dados', this.httpOptions);
  }

  getDadosPessoais(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + '/dado-pessoal/view/dados-pessoais', this.httpOptions);
  }

  apagarDadoPessoal(id) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpClient.delete(this.apiURL + `/dado-pessoal/delete/${id}`, { headers, responseType: 'text' });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/usuario/dados-pessoais/dados-pessoais.service.ts